import React, { useEffect } from "react";
import { MeasureCurrent } from "../../models/testSteps/measureCurrent.ts";
import { Current } from "../../models/signalUsers/current.ts";
import { TextField, Grid, FormControlLabel, Checkbox, MenuItem, InputAdornment } from "@mui/material";
import { getCombinedSignalLabel } from "../../utils/signalUtils.ts";

interface Props {
  data: MeasureCurrent;
  onChange: (updated: MeasureCurrent) => void;
  setIsValid: (valid: boolean) => void;
  currentOptions: Current[];
}

const EditMeasureCurrentForm: React.FC<Props> = ({ data, onChange, setIsValid, currentOptions }) => {
  useEffect(() => {
    const validId = currentOptions.some(v => v.id === data.current_id);
    const minValid = !data.enable_min || data.min >= 0;
    const maxValid = !data.enable_max || data.max >= 0;
    const minMaxValid = (data.enable_min && data.enable_max && data.max < data.min)? false : true;
    setIsValid(data.name.trim() !== "" && validId && minValid && maxValid && minMaxValid);
  }, [data, currentOptions, setIsValid]);

  const handleVoltageChange = (id: string) => {
    const current = currentOptions.find(v => v.id === id);
    if (current) {
      const label = current ? getCombinedSignalLabel(current.high_signal, current.low_signal) : "Not found";
      onChange({ ...data, current_id: id, current_name: label });
    }
  };

  
  return (
    <Grid container spacing={2} mt={1}>
      <Grid size={12}>
        <TextField
          label="Name"
          fullWidth
          value={data.name}
          onChange={(e) => onChange({ ...data, name: e.target.value })}
        />
      </Grid>
      <Grid size={12}>
        <TextField
          select
          fullWidth
          label="Strommessung auswählen"
          value={data.current_id}
          onChange={(e) => handleVoltageChange(e.target.value)}
        >
          {currentOptions.map((v) => (
            <MenuItem key={v.id} value={v.id}>{getCombinedSignalLabel(v.high_signal, v.low_signal)}</MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid size={6}>
        <FormControlLabel
          control={
            <Checkbox
              checked={data.enable_min}
              onChange={(e) => onChange({ ...data, enable_min: e.target.checked })}
            />
          }
          label="Untergrenze aktiv"
        />
        <TextField
          label="Untergrenze"
          type="number"
          fullWidth
          value={data.min}
          inputProps={{ step: 0.01, min: 0 }}
          InputProps={{ endAdornment: <InputAdornment position="end">A</InputAdornment> }}
          onChange={(e) => onChange({ ...data, min: parseFloat(e.target.value) || 0 })}
          disabled={!data.enable_min}
        />
      </Grid>
      <Grid size={6}>
        <FormControlLabel
          control={
            <Checkbox
              checked={data.enable_max}
              onChange={(e) => onChange({ ...data, enable_max: e.target.checked })}
            />
          }
          label="Obergrenze aktiv"
        />
        <TextField
          label="Obergrenze"
          type="number"
          fullWidth
          value={data.max}
          inputProps={{ step: 0.01, min: 0 }}
          InputProps={{ endAdornment: <InputAdornment position="end">A</InputAdornment> }}
          onChange={(e) => onChange({ ...data, max: parseFloat(e.target.value) || 0 })}
          disabled={!data.enable_max}
        />
      </Grid>
    </Grid>
  );
};

export default EditMeasureCurrentForm;